export const addressItem = {
  display: 'flex',
  alignItems: 'center',
  maxHeight: '25px',
  height: '25px',
};

export const geocoderItemAddress = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  paddingLeft: '5px',
};

export const geocoderItemIcon = {
  minHeight: '24px',
  minWidth: '24px',
};
